import { Box, Button, IconButton, Stack, TextField } from '@mui/material';
import React, { ForwardedRef, forwardRef, useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

interface TaskInputProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onSubmit?: (value: string) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  sx?: object; // For additional custom styling
}

const TaskInput = forwardRef<HTMLInputElement, TaskInputProps>(
  (
    {
      placeholder = 'Add new task...',
      value = '',
      onChange,
      onSubmit,
      autoFocus = true,
      disabled = false,
      sx = {},
    },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [localValue, setLocalValue] = useState(value);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      setLocalValue(newValue);
      onChange?.(newValue);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && localValue.trim()) {
        e.preventDefault();
        onSubmit?.(localValue.trim());
        setLocalValue('');
      }
    };

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#fff',
          borderRadius: 3,
          p: 3,
          transition: 'all 0.2s ease',
          ...sx,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={4}
          sx={{
            flex: 1,
            width: '100%',
          }}
        >
          <Box
            sx={(theme) => ({
              width: '40px',
              height: '35px',
              border: '1px solid #ddd',
              borderRadius: '50%',
            })}
          ></Box>

          <TextField
            inputRef={ref}
            fullWidth
            variant="standard"
            value={localValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            autoFocus={autoFocus}
            disabled={disabled}
            InputProps={{
              disableUnderline: true,
              sx: {
                fontSize: '1.3rem',
                color: 'text.primary',
                '&::placeholder': {
                  color: 'text.disabled',
                  opacity: 0.9,
                },
              },
            }}
            sx={{
              '& .MuiInputBase-input': {
                py: 1,
              },
            }}
          />

          {/* <IconButton
            // color="#fff"
            aria-label="add to shopping cart"
            size="large"
            sx={{ color: '#c084fc' }}
          >
            <AddCircleOutlineIcon fontSize="large" />
          </IconButton> */}
        </Stack>
      </Box>
    );
  }
);

TaskInput.displayName = 'TaskInput';

export default TaskInput;
